import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import axios from "axios"
import { AXIOS_API_INSTANCE } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import { useSnackbar } from 'notistack';
import { Box, IconButton, Tooltip } from "@mui/material"
import Grid from "@mui/material/Grid2"
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';

export default function RentalCategoryModal({
    rental_category,
    open,
    closeModal,
    creatingNewRentalCategory,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [my_rental_category, setRentalCategory] = React.useState(
        rental_category || {}
    )

    React.useEffect(() => {
        console.log(rental_category)
        setRentalCategory(rental_category)
    }, [rental_category])

    const handleChange = (prop) => (event, sometimes_new_value) => {
        console.log(my_rental_category)
        setRentalCategory({
            ...my_rental_category,
            [prop]: event.target.value,
        })
    }

    const save = (event) => {
        console.log(my_rental_category)
        delete my_rental_category.date_created
        delete my_rental_category.date_updated
        delete my_rental_category.rental_category
        delete my_rental_category.rental_rate_group
        if (creatingNewRentalCategory) {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.put(
                    `rentalcategories`,
                    my_rental_category
                ).then(
                    axios.spread(() => {
                        enqueueSnackbar('Successfully created category', {variant: 'success'})
                        closeModal(true)
                    })
                )
            )
        } else {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.post(
                    `rentalcategories/${my_rental_category.id}`,
                    my_rental_category
                ).then(
                    axios.spread(() => {
                        enqueueSnackbar('Successfully updated category', {variant: 'success'})
                        closeModal(true)
                    })
                )
            )
        }
    }
    const delete_rental_category = () => {
        console.log('delete category')
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.delete(`rentalcategories/${my_rental_category.id}`).then(
                axios.spread(() => {
                    enqueueSnackbar('Successfully deleted category', { variant: 'success' })
                    closeModal(true)
                })
            )
        )
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={closeModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    {creatingNewRentalCategory ? "Creating Category" : "Modifying Category"}
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Name"
                        type="text"
                        fullWidth
                        variant="filled"
                        value={my_rental_category.name || ""}
                        onChange={handleChange("name")}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="description"
                        label="Description"
                        type="text"
                        fullWidth
                        variant="filled"
                        value={my_rental_category.description || ""}
                        onChange={handleChange("description")}
                    />
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid size="auto">
                            {!creatingNewRentalCategory &&
                                <Tooltip title={my_rental_category.deletable_reason}>
                                    <span> {/* span required for tooltip events */}
                                        <Button disabled={!my_rental_category.deletable} variant='outlined' color='error' onClick={delete_rental_category} sx={{ mr: 1 }}>
                                            <DeleteIcon /> <Box sx={{ pl: 1 }}><span>Delete</span></Box>
                                        </Button>
                                    </span>
                                </Tooltip>
                            }
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={save}>
                                {creatingNewRentalCategory ? "Create" : "Save"}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}
